import React from 'react';
import { ClockIcon, SearchIcon } from 'lucide-react';
type QA = {
  q: string;
  a: string;
};
type ProblemCardProps = {
  variant: 'blue' | 'gold' | 'navy';
  title: string;
  paragraphs: string[];
  list?: string[];
  qa?: QA[];
  outro?: string[];
  highlight: string;
};
const styles = {
  blue: {
    card: 'border border-line border-l-[5px] border-l-brand bg-white',
    title: 'text-navy',
    body: 'text-ink',
    hl: 'text-brand',
    bullet: 'bg-brand',
    q: 'text-navy'
  },
  gold: {
    card: 'border border-line border-l-[5px] border-l-gold bg-white',
    title: 'text-navy',
    body: 'text-ink',
    hl: 'text-goldDark',
    bullet: 'bg-gold',
    q: 'text-navy'
  },
  navy: {
    card: 'bg-navy',
    title: 'text-white',
    body: 'text-onNavyMuted',
    hl: 'text-gold',
    bullet: 'bg-gold',
    q: 'text-white'
  }
};
export function ProblemCard({
  variant,
  title,
  paragraphs,
  list,
  qa,
  outro,
  highlight
}: ProblemCardProps) {
  const s = styles[variant];
  const Icon = variant === 'gold' ? ClockIcon : variant === 'navy' ? SearchIcon : null;
  const textCls = `text-[14px] leading-[1.45] md:text-[15px] ${s.body}`;
  return <article className={`rounded-md px-4 py-3.5 md:px-5 md:py-4 ${s.card}`} data-id="element-158" data-mp="1925us66tqebc">
      <h2 className={`font-heading text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] md:text-[24px] ${s.title}`} data-id="element-159" data-mp="151c4551zyler">
        {Icon && <Icon className="mr-2 inline h-5 w-5 -translate-y-0.5 text-gold md:h-6 md:w-6" strokeWidth={2.5} aria-hidden data-id="element-160" data-mp="100xy1sjyhljd" />}
        {title}
      </h2>
      {paragraphs.length > 0 && <div className={`mt-1.5 space-y-1.5 ${textCls}`} data-id="element-161" data-mp="1ss7tlvizd4iu">
          {paragraphs.map(p => <p key={p} data-id="element-162" data-mp="1nr1yxs5rf76o">{p}</p>)}
        </div>}
      {list && <ul className={`mt-2 space-y-1 ${textCls}`} data-id="element-163" data-mp="1ish0nya2ixkv">
          {list.map(item => <li key={item} className="flex gap-2" data-id="element-164" data-mp="cdq2w3g8rsv2">
              <span className={`mt-[0.55em] h-1.5 w-1.5 shrink-0 rounded-full ${s.bullet}`} aria-hidden data-id="element-165" data-mp="cbdd5448se7g" />
              <span data-id="element-166" data-mp="7gpwfrfhco3f">{item}</span>
            </li>)}
        </ul>}
      {qa && <dl className={`mt-2 space-y-2 ${textCls}`} data-id="element-167" data-mp="8tpofieihy35">
          {qa.map(item => <div key={item.q} data-id="element-168" data-mp="dtu3d3zrukr9">
              <dt className={`font-heading text-[13px] font-bold leading-snug md:text-[14px] ${s.q}`} data-id="element-169" data-mp="3w0i98w2nbbxz">{item.q}</dt>
              <dd className="mt-0.5" data-id="element-170" data-mp="4tffpxzc4tkl">{item.a}</dd>
            </div>)}
        </dl>}
      {outro && <div className={`mt-2 space-y-1.5 ${textCls}`} data-id="element-171" data-mp="3m9dthu55bn23">
          {outro.map(p => <p key={p} data-id="element-172" data-mp="3r1f1h3va6rmb">{p}</p>)}
        </div>}
      <p className={`mt-2 font-heading text-[12px] font-extrabold uppercase leading-tight md:text-[14px] ${s.hl}`} data-id="element-173" data-mp="3d9qsh9gbwj9k">
        {highlight}
      </p>
    </article>;
}